import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from "../../material/material.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BasicEntityFrontModule} from "../../basic-entity-front/basic-entity-front.module";
import {RegistrosEmpleadosComponent} from './registros-empleados/registros-empleados.component';
import {MatRadioModule} from "@angular/material/radio";
import { ClienteEditionComponent } from './clientes/cliente-edition/cliente-edition.component';
import {DireccionFormComponent} from './direccion-form/direccion-form.component';
import {AsociadoEditionComponent} from "../asociados/asociado-edition/asociado-edition.component";

@NgModule({
    declarations: [
        RegistrosEmpleadosComponent,
        ClienteEditionComponent,
        DireccionFormComponent,
        AsociadoEditionComponent
    ],
    imports: [
        CommonModule,
        BasicEntityFrontModule,
        ReactiveFormsModule,
        MaterialModule,
        FormsModule,
        MatRadioModule
    ],
    // DireccionFormComponent se exporta para que AsociadosModule (lazy) pueda usarlo en su propio
    // diálogo de dirección (Tarea 9); importa PersonasModule para acceder a él.
    //
    // AsociadoEditionComponent se declara aquí, y no en AsociadosModule como el resto de la sección
    // "Mis clínicas", porque ese módulo es lazy y el diálogo se abre también desde la edición de una
    // línea de pedido (TrabajosModule, eager): declararlo en un módulo cargado bajo demanda obliga a
    // arrastrar su chunk entero desde uno que ya está en el bundle inicial.
    exports: [
        DireccionFormComponent,
        AsociadoEditionComponent
    ]
})
export class PersonasModule {
}
